import React, { ReactNode } from 'react'
import styled from 'styled-components';

const StyledChildrenContainer = styled.div`
  margin: 0 auto;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const StyledChildrenContainerInner = styled.div`
  margin: 0 auto;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  position: relative;
  min-height: 200px
`;

const MarginInner = styled.div`
  margin-bottom: 50px !important;
  min-height: 100px !important;
`;

const LoadingText = styled.div`
  font-weight: 600;
`;

const Spinner = styled.div`
@keyframes sk-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
  width: 54px;
  height: 54px;
  text-align: center;
  animation: sk-rotate 2s infinite linear;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: 54px / 2 * -1;
  margin-left: 54px / 2 * -1;
  border-radius: 50%;
  border-bottom: 4px solid #000;
  border-right: 4px solid #000;
  border-left: 4px solid #fff;
  border-top: 4px solid #fff;
  top: 37%;
  margin-left: -25px;
`;

const DontOne = styled.div`
`;

const DotTwo = styled.div`
`;

const Loader: React.FC = () => {
  return (
    <StyledChildrenContainer>
      <StyledChildrenContainerInner>
        <MarginInner>
          <LoadingText></LoadingText>
          <Spinner><DontOne></DontOne><DotTwo></DotTwo></Spinner>
        </MarginInner>
      </StyledChildrenContainerInner>
    </StyledChildrenContainer>
  );
};

export default Loader;
